// The organisation the console is scoped to. There is no choice to make any more (S69): it is
// the signed-in user's personal organisation (D52) when the organisation list holds it, else
// the first organisation listed.
import { useQuery } from "@tanstack/react-query";

import type { Organisation } from "../api/client";
import { orgsQuery } from "../api/queries";
import { accessQuery } from "../auth/access";

// The org switcher's saved choice; forgotten so a stale, now invisible choice cannot linger.
try {
  localStorage.removeItem("ocs.org");
} catch {
  // Storage can be blocked (private mode); then nothing was saved either.
}

export interface CurrentOrg {
  orgs: Organisation[];
  org: Organisation | undefined;
  isPending: boolean;
}

export function resolveOrg(orgs: Organisation[], personalOrgId: string | undefined): Organisation | undefined {
  return orgs.find((o) => o.id === personalOrgId) ?? orgs[0];
}

export function useCurrentOrg(): CurrentOrg {
  const orgs = useQuery(orgsQuery());
  const me = useQuery(accessQuery());
  const list = orgs.data ?? [];
  return { orgs: list, org: resolveOrg(list, me.data?.personal_org_id), isPending: orgs.isPending || me.isPending };
}
